const tableActionCellPrefix = 'table-action-cell';

export const dataHooks = {
  triggerElement: `${tableActionCellPrefix}-trigger-element`,
  placeholder: `${tableActionCellPrefix}-placeholder`,
  primaryActionWrapper: `${tableActionCellPrefix}-primary-action-wrapper`,
  primaryAction: `${tableActionCellPrefix}-primary-action`,
  visibleActionTooltip: `${tableActionCellPrefix}-visible-action-tooltip`,
  popoverMenu: `${tableActionCellPrefix}-popover-menu`,
  popoverMenuItem: `${tableActionCellPrefix}-popover-menu-item`,
  visibleAction: `${tableActionCellPrefix}-visible-action`,
  visibleActionsWrapper: `${tableActionCellPrefix}-visible-actions-wrapper`,
  visibleActionButton: `${tableActionCellPrefix}-visible-action-button`,
};
